import Auth from "../../Auth";
import { db } from "../../Firebase";

const EXCLUDE = ["untitled"];

export default class RelatedWordsStore {
  constructor({ documentId }) {
    this.documentId = documentId;
    this.clusters = {};
  }

  async fetch(words) {
    // skip words already in clusters
    let keys = Object.keys(this.clusters);
    words = words.filter(word => !keys.includes(word));

    if (words.length === 0) {
      return;
    }

    if (words.length == 1) {
      // use client side fetch
      let related = await db.collection("relatedWords").where("word", "==", words[0]).get();

      if (related.docs[0]) {
        this.clusters[words[0]] = JSON.parse(related.docs[0].get("clusters"));
      }
    } else {
      let result = await Auth.fetchWithIdToken("/api/ai/relatedWords", { words: words, documentId: this.documentId });

      console.log(result.clusters);
      this.clusters = Object.assign(this.clusters, result.clusters);
    }
  }

  async fetchFromDoc() {
    // skip words already in clusters
    let result = await Auth.fetchWithIdToken("/api/ai/relatedWords", { getFromDoc: true, documentId: this.documentId });

    console.log(result.clusters);

    this.clusters = Object.assign(this.clusters, result.clusters);
  }

  async get(word) {
    word = word.trim().toLowerCase();

    if (EXCLUDE.includes(word)) {
      return;
    }

    if (!this.clusters[word]) {
      // Cache miss
      await this.fetch([word]);
    }

    return this.clusters[word];
  }
}
